var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.61948 4.49998L6.62838 3.50888V7.875C6.62838 8.2202 6.34858 8.5 6.00338 8.5C5.65823 8.5 5.37838 8.2202 5.37838 7.875V3.50888L4.38725 4.50001C4.14318 4.74409 3.74745 4.74409 3.50337 4.50001C3.25929 4.25594 3.25929 3.86021 3.50337 3.61613L5.56143 1.55806C5.67863 1.44085 5.83763 1.375 6.00338 1.375C6.16913 1.375 6.32813 1.44085 6.44533 1.55806L8.50338 3.61611C8.74743 3.86018 8.74743 4.25591 8.50338 4.49998C8.25928 4.74407 7.86358 4.74407 7.61948 4.49998Z",
    fill: "#666666",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0039 7.5C9.65871 7.5 9.37891 7.7798 9.37891 8.125V9.875H2.62891V8.125C2.62891 7.7798 2.34909 7.5 2.00391 7.5C1.65873 7.5 1.37891 7.7798 1.37891 8.125V10C1.37891 10.6213 1.88259 11.125 2.50391 11.125H9.50391C10.1252 11.125 10.6289 10.6213 10.6289 10V8.125C10.6289 7.7798 10.3491 7.5 10.0039 7.5Z",
    fill: "#666666",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/downloadIcon.49bb85a9e9808e657fbccf7b993828de.svg";
export { ForwardRef as ReactComponent };